import jwt_decode from 'jwt-decode'

export const getJWTPayload = (): any => {
  const jwt = window.cb.core.iam.getJWTToken()
  if (!jwt) {
    return null
  }

  return jwt_decode(jwt)
}

export const getTokens = () => {
  const jwt = window.cb.core.iam.getJWTToken()
  const authenToken = window.cb.core.iam.getAuthenticationToken()
  const authorToken = window.cb.core.iam.getAuthorizationToken()

  const payload = {
    jwt,
    authenToken,
    authorToken,
  }

  return payload
}
